import RepositoryFactory from '@/repository/RepositoryFactory';
import { showErrorNotification } from '@/util';
import {
  FLAG_ON,
  MAX_RECORDS_IN_PAGE,
  OPEN_FLAG_OPEN,
  OPEN_FLAG_CLOSE,
  CATEGORY_KIND_GROUP_CLASS,
  RECORDS_IN_PAGE_PARAMETER_NAME,
} from '@/constant';
// const categoriesRepository = RepositoryFactory.categories;
// const shiftServiceRepositories = RepositoryFactory.shiftService;

/**
 * グループ情報を取得
 * @param serviceId 園ID
 * @param search_kind 検索種別
 * @param is_all 全ての情報を取得するかどうか
 */
const getClasses = async function (getClassesParams: any) {
  const { serviceId, is_all, notify, state } = getClassesParams;

  let params: any = {};
  params.search_serviceId = serviceId || null;
  params.search_open_flag = !is_all ? OPEN_FLAG_OPEN : OPEN_FLAG_CLOSE;
  params[RECORDS_IN_PAGE_PARAMETER_NAME] = MAX_RECORDS_IN_PAGE;

  //   const fetchedClasses = await shiftServiceRepositories.absenceCategories.index();
  const fetchedClasses = {
    data: [],
  };

  return fetchedClasses.data
    .map((category: any) => {
      if (category && category.groups && Number(category.kind) === CATEGORY_KIND_GROUP_CLASS) {
        let classObj: any = {};
        classObj.id = category.id;
        classObj.type = category.name;
        classObj.open_flag = category.open_flag;
        classObj.report_flag = category.report_flag;
        // 使用状態
        classObj.active = false;
        classObj.data = category.groups
          .map((value: any) => {
            return { id: value.id, name: value.name, open_flag: value.open_flag, kind: value.kind };
          })
          .filter((classObj: any) => is_all || classObj.open_flag == FLAG_ON.toString());
        return classObj;
      }
    })
    .filter(
      (categoryClass: any) =>
        (categoryClass && categoryClass !== undefined && is_all) ||
        (categoryClass && categoryClass.open_flag === FLAG_ON.toString())
    );
};

export default getClasses;
